// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"194c26c6","498":"306319fe","513":"a0e080ce"}[chunkId] + ".chunk.js";
};